import assert from 'assert-ts';
import type {CodeList} from '../types';

export const sortByList = (codelist: CodeList, topList: string[]): CodeList => {
  return {
    ...codelist,
    codes: [
      ...topList.map(lang =>
        assert(
          codelist.codes.find(code => code.code === lang),
          `code ${lang} not found`,
        ),
      ),
      ...codelist.codes.filter(code => !topList.includes(code.code)),
    ],
  };
};
